module.exports = __webpack_public_path__ + "static/non-gmo-676b7784ff9edda3d51fcee0f4f16f58.png";